import React, { useState } from 'react';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';

const Header = ({ context }) => {
	
	const ctxGlobal 	= () => context.global;
	const global 		= ctxGlobal();
	
	const ctxSiteLoaded = () => context.siteLoaded;
    const siteLoaded 	= ctxSiteLoaded();
    
    const ctxMenuOpen 	= () => context.menu.open;
    const menuOpen 		= ctxMenuOpen();
	
	function handleMenuToggle(evt) {
	  	evt.preventDefault();
	  	context.toggleMenu();
  	}
  	
  	function linkHoverOver() {
	  	document.documentElement.classList.add('state-hover-link');
  	}
  	
  	function linkHoverOut() {
	  	document.documentElement.classList.remove('state-hover-link');
  	}
  	
			
    if (context.global) {
						
		if (global.json === null) {
			context.getGlobal(window.location.origin + '/wp-json/studio-massive/v1/global');
		}
	  		  	
	  	if (global.json !== null) {  
		  		    	
	    	let phoneEmail = '<p>';
			if (global.json.ftr_phone && global.json.ftr_phone_url) {
				phoneEmail = phoneEmail + '<a href="tel:' + global.json.ftr_phone_url + '">' + global.json.ftr_phone + '</a><br />';
			}
			if (global.json.ftr_email) {
				phoneEmail = phoneEmail + '<a href="tel:' + global.json.ftr_email + '">' + global.json.ftr_email + '</a>';
			}
			phoneEmail = phoneEmail + '</p>';
			
			let address = '<p>';
			if (global.json.ftr_address && global.json.ftr_google_maps_url) {
				address = address + '<a href="tel:' + global.json.ftr_google_maps_url + '">' + global.json.ftr_address + '</a>';
			} else if (global.json.ftr_address) {
				address = address + global.json.ftr_address;
			}
			address = address + '</p>';
			
			let instagram = '<p>';
			if (global.json.ftr_instagram_handle && global.json.ftr_instagram_url) {
				instagram = instagram + '<a href="' + global.json.ftr_instagram_url + '" target="_blank">' + global.json.ftr_instagram_handle + '</a>';
			}
			instagram = instagram + '</p>';
			
			return (
				<>
			    	<header className={'c-header ' + (menuOpen ? "state-menu-open" : "")}> 
			    		<div  className="c-header__inner"> 
							<h2 className="c-header__logo">
								<Link to={{ pathname: '/' }} className="c-header__logo__inner" onMouseOver={linkHoverOver} onMouseOut={linkHoverOut}>Studio Massive</Link>
							</h2>
							<a href="#" className="c-header__menu-button" onClick={handleMenuToggle} onMouseOver={linkHoverOver} onMouseOut={linkHoverOut}></a>
						</div>
					</header>
	
					<div className={'c-menu ' + (menuOpen ? "state-menu-open" : "")}>
						
						<div className="c-menu__inner">
							
							<div className="c-menu__section"></div>
							
							<div className="c-menu__section">
								<div className="l-content">
									<div className="l-grid">
										<div className="l-grid__col">
											<ul className="c-menu__list">
												<li className="c-menu__list__item">
													{window.location.pathname === '/information' &&
														<p className="c-menu__list__link" onClick={handleMenuToggle}>Information</p>
													}
													{window.location.pathname !== '/information' &&
														<Link to={{ pathname: '/information' }} className="c-menu__list__link">Information</Link>
													}
												</li>
												<li className="c-menu__list__item">
													{window.location.pathname === '/work' &&
														<p className="c-menu__list__link" onClick={handleMenuToggle}>Projects</p>
													}
													{window.location.pathname !== '/work' &&
														<Link to={{ pathname: '/work' }} className="c-menu__list__link">Projects</Link>
													}
												</li>
												<li className="c-menu__list__item">
													{window.location.pathname === '/contact' &&
														<p className="c-menu__list__link" onClick={handleMenuToggle}>Contact</p>
													}
													{window.location.pathname !== '/contact' &&
														<Link to={{ pathname: '/contact' }} className="c-menu__list__link">Contact</Link>
													}
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						
							<div className="c-menu__section">
		    			
				    			<div className="l-content">
				    			
				    				<div className="l-grid">
				    				
										<div className="l-grid__col l-grid__col--m-4-12 l-grid__col--l-6-12">
											<div className="scope-text scope-text--desktop scope-text--small" dangerouslySetInnerHTML={ {__html:'<h3>Contact</h3>'}}></div>
										</div>
										
										<div className="l-grid__col l-grid__col--m-8-12 l-grid__col--l-6-12">
											<div className="c-menu__contact">
												<div className="c-menu__contact__section">
													<div className="scope-text scope-text--small" dangerouslySetInnerHTML={ {__html:phoneEmail}}></div>
												</div>
												
												<div className="c-menu__contact__section">
													<div className="scope-text scope-text--small" dangerouslySetInnerHTML={ {__html:address}}></div>
												</div>
												
												<div className="c-menu__contact__section">
													<div className="scope-text scope-text--small" dangerouslySetInnerHTML={ {__html:instagram}}></div>
												</div>
											</div>
										</div>
																					
									</div>
								
								</div>
								
							</div>
							
						</div>
					</div>
				</>
			)
		
		} else {
			
			return null;
			
		}
		
	} else {
		
		return null;
		
	}
		
}
export default WithConsumer(Header);